/**
 * Internal mail — types shared between API and web.
 *
 * Every user has access by default (no grant table). Each account is
 * auto-assigned an `internalEmail` alias (e.g. `emad@peerless.mail`) used
 * as a display label; routing always happens by user id.
 */
/** Hard limits the API enforces — surfaced here so the UI can mirror them. */
export const MAIL_LIMITS = {
    subjectMaxLen: 300,
    bodyMaxLen: 50_000,
    maxRecipients: 50,
    maxAttachments: 5,
    maxAttachmentBytes: 10 * 1024 * 1024,
};
//# sourceMappingURL=mail.js.map